<template>
  <div :class="['tender-notice', isTemplate ? 'print-area' : '']">
    <tender-chapter
      v-for="(chapter, i) in chapters" :key="i"
      :chapter-index="i"
    ></tender-chapter>
  </div>
</template>
<script>
import TenderChapter from './chapter.vue'
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
export default {
  name: 'TenderNotice',
  components: {
    TenderChapter
  },
  computed: {
    ...mapState(['isTemplate']),
    ...mapGetters(['chapters'])
  }
}
</script>
<style lang="scss" scoped>
.tender-notice {
  margin: 5px;
  background: #f1f2f7;
}
.tender-notice {
  &.print-area {
    margin: 0;
    background: white;
  }
}
</style>